import React from 'react';
import { setAutomationElement } from '@experian-uk/corvetteuk-common-ui';
import Analytics, { InteractionInputEvent } from '@ecs-uk/web-common-analytics';
import { BannerBenefitsContainer, BenefitsAnchor, BenefitsHeading, BenefitsText } from './benefitsBanner.styles';
import useExperienceApi from '../../../hooks/useExperienceApi';
import abTests from '../../../constants/abtests';
import { getEnv } from '../../Context/env';
import InViewComponent from '../../InView';
import { triggerECD2EventsOnload, handleControlVariant } from '../utils/handleControlVariant';

const triggerEcd2Event = (event, cta) => {
  Analytics.publish(
    InteractionInputEvent.fromObject({
      component: cta.text,
      action: 'click',
      status: 'success',
    })
  );
  window.location.href = cta?.destination?.includes('experian') ? cta.destination : `${getEnv().REACT_APP_INS_URL}`;
};

const BenefitsBanner = () => {
  const { targetedFeaturesFlowletId, targetedFeatures, conductricsDecisions } = useExperienceApi();

  const targetedFeature = targetedFeatures?.[0];

  if ((!targetedFeature || targetedFeatures.length === 0) && conductricsDecisions.length === 0) {
    return null;
  }

  if ((!targetedFeature || targetedFeatures.length === 0) && conductricsDecisions.length > 0) {
    const benefitsDecisions = conductricsDecisions.filter(d => d.id !== abTests.PRODMOVE_PROTECT_HOOK.apiCode);
    handleControlVariant({
      targetedFeaturesFlowletId,
      conductricsDecisions: benefitsDecisions,
      defaultTestName: 'Prod Move Downsell Insights',
    });
    return null;
  }

  const {
    title = '',
    description = '',
    cta = { text: '', destination: `${getEnv().REACT_APP_INS_URL}` },
    actionName = '',
    decisionName = '',
  } = targetedFeature;

  triggerECD2EventsOnload({ testName: decisionName, testVariant: actionName });

  return (
    <InViewComponent
      label="product movement"
      data={{
        card_name: actionName,
        card_type: 'standard',
      }}
    >
      <BannerBenefitsContainer {...setAutomationElement('benefitsBanner')}>
        <BenefitsHeading>{title}</BenefitsHeading>
        <BenefitsText>{description}</BenefitsText>
        <BenefitsAnchor onClick={e => triggerEcd2Event(e, cta)}>{cta.text}</BenefitsAnchor>
      </BannerBenefitsContainer>
    </InViewComponent>
  );
};

export default BenefitsBanner;
